import { render, staticRenderFns } from "./CardPublicProfile.vue?vue&type=template&id=13f1fd1e&"
import script from "./CardPublicProfile.vue?vue&type=script&lang=js&"
export * from "./CardPublicProfile.vue?vue&type=script&lang=js&"
import style0 from "./CardPublicProfile.vue?vue&type=style&index=0&id=13f1fd1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports